import Vue from "vue";
import VueI18n from "vue-i18n";
// el  语言包引入
import en from "element-ui/lib/locale/lang/en";
import zh from "element-ui/lib/locale/lang/zh-CN";
import fr from "element-ui/lib/locale/lang/fr";
// 日语
import ja from "element-ui/lib/locale/lang/ja";
// 荷兰
import nl from "element-ui/lib/locale/lang/nl";

const languageList = ["en", "zh-CN", "fr", "ja", "nl"];
const languageDataList = {
  en: en,
  "zh-CN": zh,
  fr: fr,
  ja: ja,
  nl: nl,
};
Vue.use(VueI18n);
// 加载打包的翻译
// function loadLocaleMessages() {
//   const locales = require.context(
//     "../public/locales",
//     true,
//     /[A-Za-z0-9-_,\s]+\.json$/i
//   );
//   const messages = {};
//   locales.keys().forEach((key) => {
//     const matched = key.match(/([A-Za-z0-9-_]+)\./i);
//     if (matched && matched.length > 1) {
//       const locale = matched[1];
//       messages[locale] = locales(key);
//     }
//   });
//   console.log(messages);
//   return messages;
// }

function loadLocaleMessages() {
  const locales = require.context(
    "../public/locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
      if (languageList.includes(locale)) {
        messages[locale].el = languageDataList[locale].el;
      }
    }
  });
  return messages;
}

function loadLocalMessage(code) {
  const locales = require.context(
    "../public/locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  let message = {};
  locales.keys().forEach((key) => {
    let afterReplaceKey = key.replace("./", "").replace(".json", "");
    if (code == afterReplaceKey) {
      message = locales(key);
    }
  });

  return message;
}

function i18nMergeElemI18n(locale, message) {
  languageList.includes(locale)
    ? (message.el = languageDataList[locale].el)
    : (message.el = languageDataList["en"].el);
  return message;
}
// 用来区分生产环境和开发环境    开发环境读取文件，线上环境在App.vue 里面请求接口
const isProduction = process.env.NODE_ENV === "production";
// const isProduction = false;

export default new VueI18n({
  locale: window.HS_CONFIG.DEFAULT_LANGUAGE ?? "en",
  fallbackLocale: "en",
  messages: isProduction ? {} : loadLocaleMessages(),
});

export { loadLocaleMessages, loadLocalMessage, i18nMergeElemI18n };
